import { Injectable } from '@angular/core';
import { NetworkService } from '../infrastructure/network.service';
import { ConfigService } from '../infrastructure/config.service';
import { saveAs } from 'file-saver';

@Injectable()
export class GrowerProgramService {
  constructor(public configService: ConfigService, public networkService: NetworkService) { }

  public getGrowerProgramMasterData() {
    return this.networkService.getRequest(this.configService.getGrowerProgramMasterDataUrl);
  }
  public getGrowerProgramLandingData(filters) {
    return this.networkService.postRequest(this.configService.getGPLandingGridData(), filters);
  }

  public getGrowerProgramSeedDesDataData(filters) {
    return this.networkService.postRequest(this.configService.getGPSeedDesData(), filters);
  }

  public getExportSeedDesDataData(filters) {
    return this.networkService.postRequest(this.configService.getGPExportSeedDesData(), filters);
  }
  public saveSpendDetails(data) {
    return this.networkService.postRequest(this.configService.saveSpendDetailsDataUrl, data);
  }
  public deleteSpendDetails(data) {
    return this.networkService.postRequest(this.configService.deleteSpendDetailsDataUrl, data);
  }
  public importSpendDetailsExcelFile(data) {
    return this.networkService.postRequest(this.configService.importSpendDetailsDataUrl, data);
  }
  public getAutoSaveConfigData(processName) {
    const url = this.configService.getAutoSaveConfigUrl + '?processName=' + processName;
    return this.networkService.getRequest(url);
  }
  public exportSpendDetailsExcelFile(data) {
    return this.networkService.postRequest(this.configService.getDownloadtemplateUrl, data);
  }
  public saveGPSpendCommentDetails(commentData) {
    return this.networkService.postRequest(this.configService.saveGPSpendCommentDetailsDataUrl, commentData);
  }
  public getGPSpendCommentDetails(spendID) {
    const url = this.configService.getGPSpendCommentDetailsDataUrl + '?spendID=' + spendID;
    return this.networkService.getRequest(url);
  }
  public saveGPSubscriptionStatus(status) {
    return this.networkService.postRequest(this.configService.saveGPSubscriptionStatusUrl, status);
  }

  public updateGrowerProgramStatusVoid(data) {
    return this.networkService.postRequest(this.configService.updateGrowerProgramStatusVoidUrl, data);
  }
  
  public updateGrowerProgramManualExtraction(data) {
    return this.networkService.postRequest(this.configService.updateGrowerProgramManualExtractionUrl, data);
  }

  // Decode base64 to file
  public base64toFile(base64String, contentType, fileName) {
    const blob = this.b64toBlob(base64String, contentType, 550);
    saveAs(blob, fileName);
  }

  // Convert b64 to BLOB
  public b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    b64Data = b64Data.replace(/\s/g, ''); // IE compatibility...
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
  public approveRejectSubmitSpendDetails(requestType, data: any[]) {
    return this.networkService.postRequest(this.configService.approveRejectSubmitSpendDetailUrl + '?requestType=' + requestType, data);
  }
}
